import React, {Component} from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import VacationCreatePopup from "./VacationCreatePopup";
import ActionLink from "@mnjsplatform/components/lib/common/ActionLink";
import {formatMnDate} from "@mnjsplatform/data/lib/utils/formatData";
import confirm from "@mnjsplatform/components/lib/common/ConfirmFn";
import i18next from "i18next";
import GridView from "@mnjsplatform/components/lib/common/GridView/GridView";
import LongText from "../Common/LongText";
import AuthProvider from "@mnjsplatform/data/lib/security/authProvider";
import pathJoin from "@mnjsplatform/data/lib/utils/pathJoin";
import $ from "jquery";

class VacationList extends Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            vacationCreateVisible: false,
            vacationKey: {},
            vacationTitle: null,
            vacationReadOnly: false,
            vacationRow: null
        }
    }

    createVacationStatement = async () => {
        await this.props.dispatch(this.props.holidayAppNewItem.execute());
        await this.props.dispatch(this.props.vacationListItem.refresh());

        if (!this.props.holidayAppNewItem.isError) {
            const vacKey = this.props.holidayAppNewItem.getRow(0);
            //console.log("vacKey: ", JSON.stringify(vacKey));
            await this.props.dispatch(this.props.holidayAppItemListItem.execute(vacKey));
            const rowIndex = this.props.vacationListItem.getRowIndex(vacKey);
            const row = this.props.vacationListItem.getRow(rowIndex);
            this.setState({
                vacationCreateVisible: true,
                vacationKey: vacKey,
                vacationTitle: this.getVacationTitle(vacKey),
                vacationReadOnly: false,
                vacationRow: row
            })
        }
    }

    deleteVacation = async (key) => {
        try {
            await confirm(i18next.t("VacationList_RemoveMessage", {name: this.state.vacationTitle ? this.state.vacationTitle.toLowerCase() : ""}));
            try {
                const params = Object.assign({}, key);
                await this.props.dispatch(this.props.holidayAppDelItem.execute(params));

                if (!this.props.holidayAppNewItem.isError) {
                    await this.props.dispatch(this.props.vacationListItem.refresh());
                    this.setState({vacationCreateVisible: false});
                }
            } catch (e) {
                console.error(e);
            }
        } catch (e) {
        }
    }

    closeVacationCreate = (refresh = false) => {
        this.setState({vacationCreateVisible: false}, async () => {
            if (refresh) {
                await this.props.dispatch(this.props.vacationListItem.refresh());
            }
        })
    }

    componentDidMount() {
        this.initialize();
    }

    initialize = async() => {
        await this.props.dispatch(this.props.EDocPers_Get.execute());
        this.IsEdocPers = this.props.EDocPers_Get.getField(0, 'IsEdocPers');
    }

    selectVacationStatement = async (row) => {
        const vacKey = this.props.vacationListItem.getRowKey(row);
        await this.props.dispatch(this.props.holidayAppItemListItem.execute(Object.assign({}, vacKey)));
        this.setState({
            vacationCreateVisible: true,
            vacationKey: vacKey,
            vacationTitle: this.getVacationTitle(row),
            vacationReadOnly: row.IsSent === 1,
            vacationRow: row
        })
    }

    getVacationTitle = (row) => {
        return i18next.t("VacationList_Title", {number: row.NumApp, date: formatMnDate(row.DateCreate)});
    }

    renderVacationStatement = () => {
        return (<>
            <button type="button" className="btn btn-regular -goahead" data-dismiss="modal"
                    onClick={this.createVacationStatement}>{i18next.t('VacationList_CreateStatement')}</button>
            <GridView dataItem={this.props.vacationListItem} showHeader={false} pageSize={5} allowPagination={true}
                      readOnly={true} activePageSize={5} renderRowEx={this.renderVacationRow}/>
            {/*{this.props.vacationListItem.dataTable().map((r, i) => this.renderVacationRow({rowIndex: i, row: r}))}*/}
            {this.state.vacationCreateVisible &&
            <VacationCreatePopup onClose={this.closeVacationCreate} vacationKey={this.state.vacationKey}
                                 readOnly={this.state.vacationReadOnly}
                                 title={this.state.vacationTitle}
                                 onDelete={this.deleteVacation}
                                 appItem={this.props.holidayAppItemListItem}
                                 isEdocPers={this.IsEdocPers === 1}
                                 row={this.state.vacationRow}
            />}
            </>
        );
    }

    getStatus = (row) => {
        let className = 'badge-secondary';
        switch (row.HolidayAppState) {
            case 0: {
                className = 'badge-secondary';
                break;
            }
            case 1: {
                className = 'badge-success';
                break;
            }
            case 2: {
                className = 'badge-warning';
                break;
            }
        }
        return <span className={"badge badge-pill " + className}>{row.HolidayAppStateName}</span>
    }

    renderVacationRow = (rowData) => {
        //const badge = (rowData.row.IsSent === 1 ? null : );
        if (!rowData.row)
            return null;
        return (<tr>
                    <td className="p-1" style={{borderTop: 'none'}}>
                        <ActionLink onSelect={() => {
                            this.selectVacationStatement(rowData.row)
                        }}>
                            {this.getVacationTitle(rowData.row)}</ActionLink>
                        &nbsp;
                        {this.getStatus(rowData.row)}
                        {rowData.row.EDocIntId && this.renderFileName(rowData.row)}
                    </td>
        </tr>)
    }

    renderFileName = (row) => {
        return (
            <label>
                <a href="" rel="noopener noreferrer"
                   onClick={(event) => this.getDocument(row, event)}
                   className="mr-2">&nbsp;{row.DoDownload}</a>
            </label>
        );
    }

    getDocument = async (row, event) => {
        event.preventDefault();
        const token = await AuthProvider.getToken();
        const downloadPath = pathJoin(window.config.apiRoot, "EDDocList", "DownloadDocument") + "?" + $.param({
            b_token: token,
            id: row.EDocIntId
        });
        window.open(downloadPath, '_blank');
    }

    render() {
        if (!this.props.EDocPers_Get.isInitialized || !this.props.vacationListItem.isInitialized)
            return null;
        return this.renderVacationStatement();
    }
}

VacationList.propTypes = {
    dispatch: PropTypes.func.isRequired,
    vacationListItem : PropTypes.object,
    holidayAppNewItem: PropTypes.object,
    holidayAppDelItem: PropTypes.object,
    holidayAppItemListItem: PropTypes.object,
    EDocPers_Get: PropTypes.object
}

VacationList.defaultProps = {};

function mapStateToProps(state) {
    return {
        holidayAppNewItem: state.vacationState.HolidayAppNew,
        holidayAppDelItem: state.vacationState.HolidayAppDel,
        holidayAppItemListItem: state.vacationState.HolidayAppItemList,
        EDocPers_Get: state.docflowState.EDocPers_Get
    }
}

export default connect(mapStateToProps)(VacationList)